import { useTranslation } from "react-i18next";

export default function TandCLink() {
  const { t } = useTranslation()
  return (
    <p className={"text-center text-sm sm:mx-2 max-w-md text-gray-500"}>
      {t("terms.agree")} <br></br>{t("terms.agreeto")} {" "}
      <a
        className={"inline-block"}
        style={{ color: "#584CF4", textDecoration: "underline" }}
        href={"https://www.tikitly.com/tikitly-ticket-buyer-terms.html"}
        target="_blank" rel="noreferrer"
      >
        {t("terms.termsAndConditions")}
      </a>{" "}
      {t("terms.of")}
    </p>
  );
}
